import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Button from "elevate-ui/Button";
import Typography from "elevate-ui/Typography";

type Props = {
  classes: Object,
  className: string,
};

const LoginSignup = ({ classes, className, location }: Props) => {
  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.heading}>Let’s keep searching</div>
      <Typography type="body" className={classes.subHeading}>
        Create an account to unlock advanced search filters like amenities,
        parking, pools, and more.
      </Typography>
      <Button
        className={classes.signupBtn}
        element="a"
        href={`/signup?redirect=${encodeURIComponent(location.href)}`}
      >
        Create Account
      </Button>
      <div className={classes.closingContainer}>
        Already have an account?{" "}
        <span>
          <a
            className={classes.link}
            href={`/login?redirect=${encodeURIComponent(location.href)}`}
          >
            Log in here.
          </a>
        </span>
      </div>
    </div>
  );
};

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    margin: "64px auto 24px",
    padding: theme.spacing.unit * 1.5,
    background: "#fafafa",
    borderRadius: "4px",
  },
  heading: {
    color: theme.colors.gray["900"],
    fontWeight: "700",
    letterSpacing: ".14px",
    fontSize: "24px",
    lineHeight: "1.2",
    textAlign: "center",
    marginBottom: theme.spacing.unit * 0.75,
  },
  subHeading: {
    maxWidth: "480px",
    textAlign: "center",
    margin: "auto",
    marginBottom: theme.spacing.unit,
  },
  signupBtn: {
    margin: "16px auto",
  },
  closingContainer: {
    color: theme.colors.gray["700"],
    fontWeight: "600",
    maxWidth: "330px",
    margin: "0 auto",
  },
  link: {
    color: `${theme.colors.primary["500"]} !important`,
    textDecoration: "underline",

    "&:hover": {
      textDecoration: "none !important",
    },
  },
});

export default withStyles(styles)(LoginSignup);
